exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scenario-container {\n\n}\n\n.scenario-head {\n    padding: 10px 10px 0 10px;\n    border-bottom: 1px solid #999999;\n    display: inline-block;\n    width: 100%;\n}\n\n.scenario-entry {\n    border-top: 1px solid #999999;\n    border-right: 1px solid #999999;\n    border-left: 1px solid #999999;\n    float: left;\n    padding: 5px 15px 5px 30px;\n}\n\n.scenario-content {\n    padding: 30px 20px;\n}\n\n.scenario-content textarea {\n    resize: none;\n}\n\n.mea-period {\n    background: #dfdfdf;\n    margin-top: 30px;\n    padding: 20px;\n    border-top: 1px solid rgb(218, 218, 218);\n    width: 100%;\n    display: inline-block;\n}\n\n.period-content {\n    margin: 0 -15px;\n    padding-top: 30px;\n}\n\n.row {\n    margin-left: 0;\n    margin-right: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/new-simulation/tender-simulation-input/tender-simulation-input.component.css
// module id = ../../../../../src/app/components/new-simulation/tender-simulation-input/tender-simulation-input.component.css
// module chunks = main